import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const AutoplayModalLazy = React.lazy(() =>
  import('./AutoplayModal').then((m) => ({ default: m.AutoplayModal })),
);
type AutoplayModalProps = React.ComponentProps<typeof import('./AutoplayModal').AutoplayModal>;

NiceModal.register(
  MODALS.AUTOPLAY,
  NiceModal.create((props: AutoplayModalProps) => (
    <Suspense fallback={null}>
      <AutoplayModalLazy {...props} />
    </Suspense>
  )),
);
